export default [
  'On demand',
  'Por generación'  
]